export var ErrorType;
(function (ErrorType) {
    ErrorType["INTERNAL"] = "-1";
    ErrorType["FOLIO_EXTERNAL_OR_UNDEFINED"] = "-2";
    ErrorType["EXTERNAL_OR_UNDEFINED"] = "-3";
    ErrorType["UNKNOWN"] = "-4";
    ErrorType["AUTHENTICATION_EMAIL_NOT_VALID"] = "-5";
    ErrorType["AUTHENTICATION_PASSWORD_NOT_VALID"] = "-6";
    ErrorType["AUTHENTICATION_USER_DOES_NOT_BELONG_TO_ORGANIZATION"] = "-7";
    ErrorType["VALIDATION_ERROR"] = "-8";
    ErrorType["URL_INVALID_PROTOCOL"] = "-50";
    ErrorType["URL_MISSING_HOST"] = "-51";
    ErrorType["URL_INVALID_HOST"] = "-52";
    ErrorType["URL_MALFORMED"] = "-53";
    ErrorType["FUTURE_VOLUME_NOT_ALLOWED"] = "FUTURE_VOLUME_NOT_ALLOWED";
    ErrorType["PARENT_TITLE_VOLUME_MISMATCH"] = "PARENT_TITLE_VOLUME_MISMATCH";
    ErrorType["VOLUME_TITLE_MISMATCH"] = "VOLUME_TITLE_MISMATCH";
    ErrorType["VOLUME_NOT_FOUND"] = "VOLUME_NOT_FOUND";
    ErrorType["VOLUME_OVERLAP"] = "VOLUME_OVERLAP";
    ErrorType["VOLUME_WINDOW_INVALID"] = "VOLUME_WINDOW_INVALID";
    ErrorType["VOLUME_WINDOW_LEAVES_ISSUES"] = "VOLUME_WINDOW_LEAVES_ISSUES";
    ErrorType["VOLUME_WINDOW_NUMBER_COLLISION"] = "VOLUME_WINDOW_NUMBER_COLLISION";
    ErrorType["VOLUME_WINDOW_FREED_PERIOD_UNRESOLVED"] = "VOLUME_WINDOW_FREED_PERIOD_UNRESOLVED";
    ErrorType["VOLUME_WINDOW_NO_NEIGHBOUR"] = "VOLUME_WINDOW_NO_NEIGHBOUR";
    ErrorType["VOLUME_NOT_EMPTY"] = "VOLUME_NOT_EMPTY";
    ErrorType["VOLUME_ANCHOR_INVALID"] = "VOLUME_ANCHOR_INVALID";
    ErrorType["SCHEDULE_PLAN_STALE"] = "SCHEDULE_PLAN_STALE";
    ErrorType["VOLUME_WINDOW_PLAN_STALE"] = "VOLUME_WINDOW_PLAN_STALE";
    ErrorType["ISSUE_DATE_OUTSIDE_VOLUME"] = "ISSUE_DATE_OUTSIDE_VOLUME";
    ErrorType["PLAN_TOKEN_REQUIRED"] = "PLAN_TOKEN_REQUIRED";
    ErrorType["MANUAL_FREQUENCY_REQUIRED"] = "MANUAL_FREQUENCY_REQUIRED";
    ErrorType["CONTINUOUS_NUMBERING_PLAN_STALE"] = "CONTINUOUS_NUMBERING_PLAN_STALE";
    ErrorType["CONTINUOUS_NUMBERING_START_REQUIRED"] = "CONTINUOUS_NUMBERING_START_REQUIRED";
    ErrorType["CONTINUOUS_NUMBERING_BACKWARD_BELOW_ONE"] = "CONTINUOUS_NUMBERING_BACKWARD_BELOW_ONE";
    ErrorType["CONTINUOUS_NUMBERING_NUMBER_TOO_HIGH"] = "CONTINUOUS_NUMBERING_NUMBER_TOO_HIGH";
    ErrorType["ISSUE_NUMBER_EDIT_NOT_ALLOWED"] = "ISSUE_NUMBER_EDIT_NOT_ALLOWED";
    ErrorType["ISSUE_NUMBER_TAKEN"] = "ISSUE_NUMBER_TAKEN";
    ErrorType["CROSS_VOLUME_NOT_EDGE_ISSUES"] = "CROSS_VOLUME_NOT_EDGE_ISSUES";
    ErrorType["DIFFERENT_VOLUMES"] = "DIFFERENT_VOLUMES";
    ErrorType["UNKNOWN_KULT_SUBJECT_GROUP"] = "UNKNOWN_KULT_SUBJECT_GROUP";
    ErrorType["CROSS_LIBRARY_REPORT_NOT_ALLOWED"] = "CROSS_LIBRARY_REPORT_NOT_ALLOWED";
    ErrorType["ACTIVE_LIBRARY_LOOKUP_FAILED"] = "ACTIVE_LIBRARY_LOOKUP_FAILED";
    ErrorType["PUBLISHER_NOT_OWNED_LOCALLY"] = "PUBLISHER_NOT_OWNED_LOCALLY";
    ErrorType["PUBLISHER_NOT_FOUND_UPSTREAM"] = "PUBLISHER_NOT_FOUND_UPSTREAM";
    ErrorType["PUBLISHERS_MODULE_UNAVAILABLE"] = "PUBLISHERS_MODULE_UNAVAILABLE";
    ErrorType["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    ErrorType["LIBRARY_HARVEST_ALREADY_RUNNING"] = "LIBRARY_HARVEST_ALREADY_RUNNING";
    ErrorType["LIBRARY_HARVEST_NO_OAI_URL"] = "LIBRARY_HARVEST_NO_OAI_URL";
    ErrorType["LIBRARY_HARVEST_UNSUPPORTED_SYSTEM"] = "LIBRARY_HARVEST_UNSUPPORTED_SYSTEM";
    ErrorType["LIBRARY_HARVEST_DISABLED"] = "LIBRARY_HARVEST_DISABLED";
    ErrorType["AGENDA_FREQUENCY_REQUIRED"] = "AGENDA_FREQUENCY_REQUIRED";
    ErrorType["AGENDA_ISSUE_MERGED"] = "AGENDA_ISSUE_MERGED";
    ErrorType["LINK_MONOGRAPH_REQUIRED"] = "LINK_MONOGRAPH_REQUIRED";
    ErrorType["MONOGRAPH_ISBN_UNKNOWN"] = "MONOGRAPH_ISBN_UNKNOWN";
    ErrorType["MONOGRAPH_ISBN_AMBIGUOUS"] = "MONOGRAPH_ISBN_AMBIGUOUS";
    ErrorType["SPECIAL_ISSUE_ALREADY_LINKED"] = "SPECIAL_ISSUE_ALREADY_LINKED";
    ErrorType["LINK_TARGET_NOT_MONOGRAPH"] = "LINK_TARGET_NOT_MONOGRAPH";
    ErrorType["LINK_TARGET_NOT_PERIODICAL"] = "LINK_TARGET_NOT_PERIODICAL";
    ErrorType["LINK_TARGET_HAS_PERIODICAL_STRUCTURE"] = "LINK_TARGET_HAS_PERIODICAL_STRUCTURE";
    ErrorType["MONOGRAPH_ALREADY_LINKED"] = "MONOGRAPH_ALREADY_LINKED";
    ErrorType["SPECIAL_ISSUE_LINK_NOT_FOUND"] = "SPECIAL_ISSUE_LINK_NOT_FOUND";
    ErrorType["SPECIAL_ISSUE_LINK_IN_USE"] = "SPECIAL_ISSUE_LINK_IN_USE";
    ErrorType["SPECIAL_ISSUE_LINK_NOT_JOINED"] = "SPECIAL_ISSUE_LINK_NOT_JOINED";
    ErrorType["GLOBAL_TYPE_NATIONAL_ONLY"] = "GLOBAL_TYPE_NATIONAL_ONLY";
    ErrorType["GLOBAL_TYPE_LINKED_MONOGRAPH"] = "GLOBAL_TYPE_LINKED_MONOGRAPH";
    ErrorType["SPECIAL_ISSUE_LINKED_TO_MONOGRAPH"] = "SPECIAL_ISSUE_LINKED_TO_MONOGRAPH";
    ErrorType["SPECIAL_ISSUE_LINKED"] = "SPECIAL_ISSUE_LINKED";
    ErrorType["EXTRA_COPY_NOT_IN_MONOGRAPH_AGENDA"] = "EXTRA_COPY_NOT_IN_MONOGRAPH_AGENDA";
    ErrorType["NO_ACTIVE_LIBRARY"] = "NO_ACTIVE_LIBRARY";
    ErrorType["NOT_IN_MONOGRAPH_AGENDA"] = "NOT_IN_MONOGRAPH_AGENDA";
    ErrorType["EXTRA_COPY_ISSUE_MERGED"] = "EXTRA_COPY_ISSUE_MERGED";
    ErrorType["EXTRA_COPY_ISSUE_NOT_OF_TITLE"] = "EXTRA_COPY_ISSUE_NOT_OF_TITLE";
    ErrorType["AGENDA_STATE_REQUIRES_LIBRARY"] = "AGENDA_STATE_REQUIRES_LIBRARY";
    ErrorType["REQUEST_COPY_ISSUE_NOT_SUPPORTED"] = "REQUEST_COPY_ISSUE_NOT_SUPPORTED";
})(ErrorType || (ErrorType = {}));
